"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
const react_1 = __importDefault(require("react"));
const localStorage_1 = require("@/utilities/localStorage");
// import { values } from "lodash";
exports.defaultOptions = {
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    reviver: function (key, value) {
        if (typeof value === "string") {
            const a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
            if (a)
                return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
        }
        return value;
    },
};
function useLocalStorage(key, defaultValue) {
    const [state, setState] = react_1.default.useState(() => {
        const valueInLocalStorage = (0, localStorage_1.getItemFromLocalStorage)(key, defaultValue);
        if (valueInLocalStorage) {
            return valueInLocalStorage;
        }
        return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    });
    react_1.default.useEffect(() => {
        (0, localStorage_1.setItemInLocalStorage)(key, state);
    }, [key, state]);
    return [state, setState];
}
exports.default = useLocalStorage;
